import { Button } from "./Button";
import { ButtonWrapperProps } from "../../../types";
import { successOutlineClass, successSolidClass } from "./buttonStyles";

export const SuccessButton = ({
  children,
  cssClass,
  variant = "solid",
  disabled,
  testId,
  onClick,
}: ButtonWrapperProps) => {
  return (
    <Button
      testId={testId}
      disabled={disabled}
      onClick={() => onClick && onClick()}
      cssClass={`${
        variant === "outline" ? successOutlineClass : successSolidClass
      } ${cssClass ? cssClass : ""}`}
    >
      {children}
    </Button>
  );
};
